import {UserId} from 'records/User';
import {Moment} from 'moment';
import {coachingApi} from 'sources/api';
import CoachingPlan, {PlanId} from 'records/CoachingPlan';
import {List, Map} from 'immutable';
import {Int} from '@store/@types/util';
import {CoachingPlanVelocity} from 'records/CoachingPlanVelocity';
import pairsToMap, {KotlinPair} from 'utils/pairsToMap';

export interface FetchRepPlansRequest {
  repId: UserId;
  startDate: Moment;
  endDate: Moment;
}

interface FetchVelocityRequest {
  planIds: PlanId[];
}

const DateFMT = 'YYYY-MM-DD';
export class RepCoachingSource {
  static fetchRepPlans({
    repId,
    startDate,
    endDate,
  }: FetchRepPlansRequest): Promise<List<CoachingPlan>> {
    return coachingApi
      .getJson<List<CoachingPlan>>(`/plans/rep/${repId}`, {
        params: {
          startDate: startDate.format(DateFMT),
          endDate: endDate.format(DateFMT),
        },
      })
      .then(plans => List(plans.map(plan => new CoachingPlan(plan))));
  }

  static fetchTimeSpent(planIds: PlanId[]): Promise<Map<PlanId, Int>> {
    return coachingApi
      .getJson<KotlinPair<PlanId, Int>[]>(`/plans/time_spent`, {
        params: {
          planIds: planIds,
        },
      })
      .then(pairsToMap);
  }

  static fetchVelocity(planIds: PlanId[]): Promise<List<CoachingPlanVelocity>> {
    return coachingApi
      .postJson<FetchVelocityRequest, CoachingPlanVelocity[]>(`/plans/fetch_velocity`, {
        planIds,
      })
      .then(res => List(res));
  }
}
